import useAutoHoverAnimation from '../../hooks/useAutoHoverAnimation';

export default function HeroBanner() {
    const titleRef = useAutoHoverAnimation(100, 100, 600);

    return (
        <>
            <div id="hero">
                <div id="hero-video-background">
                    <img src="/images/contact-page-banner.jpeg" alt="Contact Us Hero" />
                </div>
                <div id="hero-styles">
                    <div id="hero-caption" className="height-title content-full-width text-align-center parallax-scroll-caption">
                        <div className="inner">
                            <h1 ref={titleRef} className="hero-title caption-timeline primary-font-title">
                                <div>
                                    <span>C</span>
                                    <span>O</span>
                                    <span>N</span>
                                    <span>T</span>
                                    <span>A</span>
                                    <span>C</span>
                                    <span>T</span>
                                    <span>&nbsp;</span>
                                    <span>U</span>
                                    <span>S</span>
                                </div>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 